import React, { MouseEvent } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isDesktop } from 'react-device-detect';
import {
  HandPalmIcon,
  MicOnIcon,
  MonitorArrowUp,
  RotationIcon,
  SignOutIcon,
} from '@icons';
import ToolItem from './ToolItem';
import { useStyles } from './styles';
import { useTrainerToolsContent as useTrainerTools } from '@features/TrainerTools/provider';
import { Screens } from '@features/TrainerTools/interfaces';
import { useHomeBottomBarContext } from '@core/dashboard/components/HomeBottomBar/providers/HomeBottomBarProvider/HomeBottomBarProvider';
import { useScreenShare } from '@core/dashboard/components/HomeBottomBar/ScreenShareButton';
import useStopSession from '@features/TrainerTools/hooks/useStopSession';
import { useParticipantList } from '@core/dashboard/components/HomeBottomBar/Participants';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useConference } from '@core/dashboard/components/DashboardContent/Dolby';

interface ToolsProps {
  onClose?: () => void;
}

const Tools = ({ onClose }: ToolsProps) => {
  const classes = useStyles();

  const { t: translate } = useTranslation();

  const { setActiveScreen } = useTrainerTools();
  const { openRaisedHands } = useHomeBottomBarContext();
  const handleShareScreen = useScreenShare();
  const { canShareScreen } = useMytaverseEvent();
  const { ueScreenScreenName } = useConference();

  const handleConfirmLogout = useStopSession();

  const { setOpen: openParticipants } = useParticipantList();

  const handleOpenRaisedHands = () => {
    openRaisedHands();
    onClose?.();
  };

  return (
    <Box sx={classes.root}>
      {isDesktop && (
        <ToolItem
          icon={RotationIcon}
          name={translate('trainerToolModal.list.item1.title')}
          description={translate('trainerToolModal.list.item1.info')}
          onClick={() => setActiveScreen(Screens.COLLECTION)}
        />
      )}
      {canShareScreen && !!ueScreenScreenName && (
        <ToolItem
          icon={MonitorArrowUp}
          name={translate('trainerToolModal.list.item2.title')}
          description={translate('trainerToolModal.list.item2.info')}
          onClick={handleShareScreen}
        />
      )}
      <ToolItem
        icon={HandPalmIcon}
        name={translate('trainerToolModal.list.item3.title')}
        description={translate('trainerToolModal.list.item3.info')}
        onClick={handleOpenRaisedHands}
      />
      <ToolItem
        icon={MicOnIcon}
        name={translate('trainerToolModal.list.item4.title')}
        description={translate('trainerToolModal.list.item4.info')}
        onClick={(event: MouseEvent<HTMLDivElement>) => {
          event.stopPropagation();
          event.preventDefault();

          openParticipants(true);
          onClose?.();
        }}
      />
      <ToolItem
        icon={SignOutIcon}
        name={translate('trainerToolModal.list.item5.title')}
        description={translate('trainerToolModal.list.item5.info')}
        onClick={() => handleConfirmLogout()}
      />
    </Box>
  );
};

export default Tools;
